module.exports = __webpack_public_path__ + "img/vakbekwaamheid.36af8da2.png";